(() => {
  if (customElements.get('lf-cookie-banner')) return;

  // 纯前端记录：同意后此浏览器不再弹出；拒绝或关闭后 7 天内不再弹出。
  const STORAGE_KEY = 'lf-cookie-choice';
  const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
  const CHOICES = ['accepted', 'rejected', 'dismissed'];

  const readChoice = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch {
      return null;
    }
  };

  const writeChoice = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, at: Date.now() }));
    } catch {
      // 存储不可用时仅关闭当前页面的提示。
    }
  };

  const isSettled = () => {
    const saved = readChoice();
    if (!saved || !CHOICES.includes(saved.choice)) return false;
    if (saved.choice === 'accepted') return true;
    const elapsed = Date.now() - Number(saved.at);
    return elapsed >= 0 && elapsed < SNOOZE_MS;
  };

  customElements.define('lf-cookie-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-cookie-choice]');
        if (!button || !this.contains(button)) return;
        const choice = button.dataset.cookieChoice;
        if (CHOICES.includes(choice)) writeChoice(choice);
        this.hidden = true;
      }, { signal });
      window.addEventListener('pageshow', () => this.refresh(), { signal });
      this.refresh();
    }

    refresh() {
      this.hidden = isSettled();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
})();
